"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areasGetPropertiesInAreaAreasPropertiesGet = areasGetPropertiesInAreaAreasPropertiesGet;
const encodings_js_1 = require("../lib/encodings.js");
const M = __importStar(require("../lib/matchers.js"));
const primitives_js_1 = require("../lib/primitives.js");
const schemas_js_1 = require("../lib/schemas.js");
const security_js_1 = require("../lib/security.js");
const url_js_1 = require("../lib/url.js");
const errors = __importStar(require("../sdk/models/errors/index.js"));
const operations = __importStar(require("../sdk/models/operations/index.js"));
const shared = __importStar(require("../sdk/models/shared/index.js"));
const async_js_1 = require("../sdk/types/async.js");
/**
 * Get Properties In Area
 *
 * @remarks
 * Get properties within an area.
 *
 * - This endpoint functions similarly similar to `/properties/{street_group_property_id}` except it returns multiple properties
 * using an area.
 * - The properties returned have a [smaller subset of fields](#model/multipleproperty) to accomodate for the larger response size.
 *
 * ## Valid query parameters
 *
 * <details>
 * <summary>Click to view information on valid query parameters for this endpoint</summary>
 *
 * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request` with details why they are not valid.
 *
 * | Combination                                                                | Description                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            |
 * | :------------------------------------------------------------------------- | :----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
 * | Postcode only                                                              | Will return only the properties in the postcode.                                                                                                                                                                                                                                                                                                                                                                                                                                                       |
 * | Outcode only                                                               | Will return only the properties in the outcode.                                                                                                                                                                                                                                                                                                                                                                                                                                                        |
 * | Sector only                                                                | Will return only the properties in the Spectre Sector (e.g `M28 1`). This parameter can be passed multiple times or a single time as a `\|` delimited string to get multiple sectors.                                                                                                                                                                                                                                                                                                                  |
 * | Single point parameter and radius                                          | Will return all properties within the radius of the lat/lon given. The parameter `filter[sectors]` can be used with this parameter to filter results.                                                                                                                                                                                                                                                                                                                                                  |
 * | Multiple point parameters                                                  | Will return all properties enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. The parameter `filter[sectors]` can be used with this parameter to filter results.                                                                                                                                                                                                                                                         |
 * | Royal Mail post town and thoroughfare (_with optional dependent locality_) | Will return all properties that align with the provided Royal Mail address values. Moreover, it offers the option to include the Royal Mail dependent locality parameter for further filtering based on address criteria. For instance, in scenarios where numerous "Main Streets" exist within a single post-town region, the dependent locality parameter assists in filtering to the correct locale, such as a village name. ([see PAF locality](https://en.wikipedia.org/wiki/Post_town#Locality)) |
 *
 * </details>
 *
 * ## Pagination
 *
 * <details>
 * <summary>Click to view information on using pagination for this endpoint</summary>
 *
 *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
 * </details>
 *
 * ### Filtering
 *
 * <details>
 * <summary>Click to view information on filtering results</summary>
 *
 * Other `filter[]` query parameters can be included in any combination to allow for filtering of the result set.
 *
 * When using a lat/lon + radius or a polygon search, you can use the parameter `filter[sectors]` which takes multiple values to filter properties to sectors.
 * </details>
 *
 * ## Multiple valued query parameters
 *
 * <details>
 * <summary>Click to view information on using query parameters that take multiple values</summary>
 *
 * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
 *
 * </details>
 *
 * ## Sorting
 *
 * <details>
 * <summary>Click to view information on using sorting for this endpoint</summary>
 *
 * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-sorting) for more information on using sorting.
 *
 * </details>
 */
function areasGetPropertiesInAreaAreasPropertiesGet(client, security, request, options) {
    return new async_js_1.APIPromise($do(client, security, request, options));
}
async function $do(client, security, request, options) {
    const parsed = (0, schemas_js_1.safeParse)(request, (value) => operations.GetPropertiesInAreaAreasPropertiesGetRequest$outboundSchema
        .parse(value), "Input validation failed");
    if (!parsed.ok) {
        return [parsed, { status: "invalid" }];
    }
    const payload = parsed.value;
    const body = null;
    const path = (0, url_js_1.pathToFunc)("/areas/properties")();
    const query = (0, encodings_js_1.encodeFormQuery)({
        "fields[property]": payload["fields[property]"],
        "filter[company_owned]": payload["filter[company_owned]"],
        "filter[council_tax_band]": payload["filter[council_tax_band]"],
        "filter[energy_efficiency_current_rating]": payload["filter[energy_efficiency_current_rating]"],
        "filter[exclude_known_rented]": payload["filter[exclude_known_rented]"],
        "filter[garden_direction]": payload["filter[garden_direction]"],
        "filter[has_hmo]": payload["filter[has_hmo]"],
        "filter[include_none_residential]": payload["filter[include_none_residential]"],
        "filter[is_bungalow]": payload["filter[is_bungalow]"],
        "filter[is_on_the_market]": payload["filter[is_on_the_market]"],
        "filter[max_internal_area_square_metres]": payload["filter[max_internal_area_square_metres]"],
        "filter[max_number_of_bedrooms]": payload["filter[max_number_of_bedrooms]"],
        "filter[max_outdoor_space_area_square_metres]": payload["filter[max_outdoor_space_area_square_metres]"],
        "filter[max_price_rounded]": payload["filter[max_price_rounded]"],
        "filter[max_price]": payload["filter[max_price]"],
        "filter[max_year_built]": payload["filter[max_year_built]"],
        "filter[max_years_at_property]": payload["filter[max_years_at_property]"],
        "filter[min_internal_area_square_metres]": payload["filter[min_internal_area_square_metres]"],
        "filter[min_number_of_bedrooms]": payload["filter[min_number_of_bedrooms]"],
        "filter[min_outdoor_space_area_square_metres]": payload["filter[min_outdoor_space_area_square_metres]"],
        "filter[min_price_rounded]": payload["filter[min_price_rounded]"],
        "filter[min_price]": payload["filter[min_price]"],
        "filter[min_year_built]": payload["filter[min_year_built]"],
        "filter[min_years_at_property]": payload["filter[min_years_at_property]"],
        "filter[number_of_bedrooms]": payload["filter[number_of_bedrooms]"],
        "filter[overseas_company_owned]": payload["filter[overseas_company_owned]"],
        "filter[property_type]": payload["filter[property_type]"],
        "filter[sectors]": payload["filter[sectors]"],
        "filter[tenure]": payload["filter[tenure]"],
        "outcode": payload.outcode,
        "page": payload.page,
        "point": payload.point,
        "postcode": payload.postcode,
        "radius": payload.radius,
        "results": payload.results,
        "royal_mail_dependent_locality": payload.royal_mail_dependent_locality,
        "royal_mail_post_town": payload.royal_mail_post_town,
        "royal_mail_thoroughfare": payload.royal_mail_thoroughfare,
        "sector": payload.sector,
        "sort": payload.sort,
    });
    const headers = new Headers((0, primitives_js_1.compactMap)({
        Accept: "application/json",
    }));
    const requestSecurity = (0, security_js_1.resolveSecurity)([
        {
            fieldName: "Authorization",
            type: "http:bearer",
            value: security?.bearer,
        },
    ], [
        {
            fieldName: "x-api-key",
            type: "apiKey:header",
            value: security?.xApiKey,
        },
    ]);
    const context = {
        options: client._options,
        baseURL: options?.serverURL ?? client._baseURL ?? "",
        operationID: "get_properties_in_area_areas_properties_get",
        oAuth2Scopes: null,
        resolvedSecurity: requestSecurity,
        securitySource: security,
        retryConfig: options?.retries
            || client._options.retryConfig
            || { strategy: "none" },
        retryCodes: options?.retryCodes || ["429", "500", "502", "503", "504"],
    };
    const requestRes = client._createRequest(context, {
        security: requestSecurity,
        method: "GET",
        baseURL: options?.serverURL,
        path: path,
        headers: headers,
        query: query,
        body: body,
        userAgent: client._options.userAgent,
        timeoutMs: options?.timeoutMs || client._options.timeoutMs || -1,
    }, options);
    if (!requestRes.ok) {
        return [requestRes, { status: "invalid" }];
    }
    const req = requestRes.value;
    const doResult = await client._do(req, {
        context,
        errorCodes: ["400", "404", "422", "429", "4XX", "500", "5XX"],
        retryConfig: context.retryConfig,
        retryCodes: context.retryCodes,
    });
    if (!doResult.ok) {
        return [doResult, { status: "request-error", request: req }];
    }
    const response = doResult.value;
    const responseFields = {
        HttpMeta: { Response: response, Request: req },
    };
    const [result] = await M.match(M.json(200, shared.AreaPropertyDetailResponse$inboundSchema), M.jsonErr(422, errors.FastAPIErrorAttributes$inboundSchema), M.jsonErr([400, 404, 429], errors.KrakenErrorAttributes$inboundSchema), M.jsonErr(500, errors.KrakenErrorAttributes$inboundSchema), M.fail("4XX"), M.fail("5XX"))(response, req, { extraFields: responseFields });
    if (!result.ok) {
        return [result, { status: "complete", request: req, response }];
    }
    return [result, { status: "complete", request: req, response }];
}
//# sourceMappingURL=areasGetPropertiesInAreaAreasPropertiesGet.js.map